// extracted by mini-css-extract-plugin
export var avatarContainer = "_9g-0";
export var avatarTypingWave = "_9g-i";
export var gray = "_9g-f";
export var green = "_9g-c";
export var icon = "_9g-9";
export var image = "_9g-1";
export var lg = "_9g-6";
export var md = "_9g-5";
export var presenceDot = "_9g-b";
export var red = "_9g-d";
export var sm = "_9g-4";
export var status = "_9g-a";
export var typingDot = "_9g-h";
export var typingPill = "_9g-g";
export var xl = "_9g-7";
export var xs = "_9g-3";
export var xxl = "_9g-8";
export var xxs = "_9g-2";
export var yellow = "_9g-e";